import React, { useState, useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import Loader from "../../Loader";
import PopUp from "../../PopUp";
import {
  getPrepaidExpenses,
  deletePrepaidExpense,
} from "../../../services/apiSubPayments";
import moment from "moment";
import AddPrepaidExpense from "./AddPrepaidExpense";

const PrepaidExpense = () => {
  const [selectedRow, setSelectedRow] = useState(null);
  const [open, setOpen] = useState(false);
  const [listResponse, setListResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openPopUp, setOpenPopUp] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [errors, setErrors] = useState({});

  const openDialog = () => {
    handleClickOpen();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
    setSelectedRow(null);
    setErrors({});
    fetchListResponse();
  };
  const handleAddUser = (newUsers) => {
    fetchListResponse();
    setOpen(false);
  };
  const handleEdit = (row) => {
    setSelectedRow(row);
    setEditMode(true);
    openDialog();
  };
  const handleDelete = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (item?._id) {
          try {
            let payload = {
              prepaidExpenseId: item?._id,
            };
            const response = await deletePrepaidExpense(payload);
            setMessage("Prepaid Expense deleted successfully");
            setOpenPopUp(true);
            fetchListResponse();
          } catch (error) {
            Swal.fire("Error deleting Role");
            fetchListResponse();
          }
        }
      }
    });
  };

  const NoRowsOverlay = () => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "gray",
      }}
    >
      <Typography>No Record Found</Typography>
    </Box>
  );

  const columns = [
    { field: "expenseDesc", headerName: "Expense Description", flex: 2 },

    { field: "amount", headerName: "Amount", flex: 2 },
    { field: "paymentDate", headerName: "Payment Date", flex: 2 },
    { field: "bank", headerName: "Bank", flex: 2 },
    { field: "modeofPayment", headerName: "Mode Of Payment", flex: 2 },
    {
      field: "actions",
      headerName: "Action",
      flex: 0,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <EditIcon sx={{ fontSize: "19px" }} />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => handleDelete(params.row)}
          >
            <DeleteIcon sx={{ fontSize: "19px" }} />
          </IconButton>
        </>
      ),
    },
  ];

  const [paymentDate, setPaymentDate] = useState("");
  const [uiFilterType, setUiFilterType] = useState("year"); // Default to "monthly"
  const [filterType, setFilterType] = useState("year");
  const [selectedMonth, setSelectedMonth] = useState(
    (new Date().getMonth() + 1).toString(),
  ); // Default to current month
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear()); // Default to current year

  const months = [
    { name: "January", value: "01" },
    { name: "February", value: "02" },
    { name: "March", value: "03" },
    { name: "April", value: "04" },
    { name: "May", value: "05" },
    { name: "June", value: "06" },
    { name: "July", value: "07" },
    { name: "August", value: "08" },
    { name: "September", value: "09" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" },
  ];

  // Generate an array of years (e.g., 2000 to 2030)
  const startYear = 2020;
  const currentYear = new Date().getFullYear();

  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, index) => startYear + index,
  );

  const handleMonthChange = (event) => {
    const newMonth = event.target.value;
    setSelectedMonth(newMonth);
    setPaymentDate("");
  };

  const handleYearChange = (event) => {
    const newYear = parseInt(event.target.value, 10);
    console.log(newYear, "newYear_handleYearChange");
    setSelectedYear(newYear);
    setPaymentDate("");
  };

  const handleFilterTypeChange = (event) => {
    const newFilterType = event.target.value;
    if (newFilterType == "year") {
      setSelectedYear(new Date().getFullYear());
    } else if (newFilterType == "month") {
      setSelectedMonth((new Date().getMonth() + 1).toString());
    }
    setFilterType(newFilterType);
    setUiFilterType(newFilterType);
    setPaymentDate("");
  };

  const fetchListResponse = async () => {
    let payload = {
      filter: filterType,
      month: selectedMonth,
      year: selectedYear,
      paymentDate: paymentDate,
    };
    console.log(payload, "payload_getReport");
    // setIsLoading(true); // Show loader
    try {
      const response = await getPrepaidExpenses(payload);
      // setIsLoading(false); // Hide loader
      setListResponse(response?.expenses);
    } catch (error) {
      console.error("Failed to fetch quotations:", error);
      // setIsLoading(false); // Hide loader
    }
  };

  const handlePaymentDateChange = (e) => {
    setPaymentDate(e.target.value);
    setSelectedYear("");
    setSelectedMonth("");
    setFilterType("");
  };

  useEffect(() => {
    console.log(paymentDate, "paymentDate");
    console.log(selectedMonth, "selectedMonth");
    console.log(selectedYear, "selectedYear");
    fetchListResponse();
  }, [selectedMonth, selectedYear, paymentDate, filterType]);

  return (
    <>
      <div className="row align-items-center m-2">
        <div className="col-lg-2">
          <div className="">
            <label htmlFor="exampleFormControlInput1" className="form-label">
              Payment Date:
            </label>
            <div className="vessel-select">
              <input
                name="paymentDate"
                type="date"
                className="form-control custom-picker-styles"
                value={paymentDate}
                onChange={handlePaymentDateChange}
              />
            </div>
          </div>
        </div>
        <div className="col-lg-2 mt-4">
          <div className="filtermainpetty d-flex align-items-center">
            <i className="bi bi-funnel-fill filtericon"></i>
            <select
              className="form-select form-select-sm filtercostcenter"
              aria-label="Filter select"
              value={filterType} // Bind selected value
              onChange={handleFilterTypeChange} // Update state on change
            >
              <option value="month">Monthly</option>
              <option value="year">Yearly</option>
            </select>
          </div>
        </div>
        {uiFilterType === "month" && (
          <>
            <div className="col-lg-2 ">
              <div className="">
                <div className="jobfilter">
                  <div></div>
                  <div>
                    <label className="form-label">Month :</label>
                    <select
                      className="form-select vesselbox"
                      value={selectedMonth}
                      onChange={handleMonthChange} // Update state on change
                    >
                      <option value="">Select Month</option>
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {uiFilterType === "year" && (
          <>
            <div className="col-lg-2 mt-4">
              <select
                className="form-select vesselbox"
                value={selectedYear} // Bind the selected value
                onChange={handleYearChange} // Update state on change
              >
                <option value="">Select Year</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </>
        )}

        <div className="col-lg-3 mt-4">
          <button
            onClick={() => {
              openDialog();
            }}
            className="btn btna submit-button btnfsize"
          >
            Add Prepaid Expense
          </button>
        </div>
      </div>

      <AddPrepaidExpense
        open={open}
        onAddUser={handleAddUser}
        onClose={handleClose}
        editMode={editMode}
        userSet={selectedRow}
        errors={errors}
        setErrors={setErrors}
      />
      <div className="m-3">
        <DataGrid
          rows={listResponse.map((item) => ({
            ...item,
            id: item._id,
            expenseDesc: item.expenseDesc || "N/A",
            bank: item.bank?.bankName ?? "N/A",
            modeofPayment: item.modeofPayment ?? "N/A",
            vendor: item.vendorId?.vendorName ?? "N/A",
            modeofPayment: item.modeofPayment || "N/A",
            amount: item.amount ?? "N/A",
            paymentDate: item.paymentDate
              ? moment(item.paymentDate).format("DD-MM-YYYY")
              : "N/A",
          }))}
          columns={columns}
          getRowId={(row) => row._id} // Use id field for unique row identification
          disableSelectionOnClick // Disables checkbox selection to prevent empty column
          disableColumnMenu // Removes column menu
          components={{
            NoRowsOverlay,
          }}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#eee !important", // Set gray background color
              color: "#000000", // Set white text color for contrast
              fontWeight: "bold", // Optional: Make the text bold
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
            "& .MuiTablePagination-toolbar": {
              alignItems: "baseline", // Apply align-items baseline
            },
            "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
            "& .MuiDataGrid-footerContainer": {
              backgroundColor: "#eee", // Gray background for the footer
            },
          }}
          pagination // Enables pagination
          pageSizeOptions={[5, 10, 20, 50, 100]} // Sets available page size options
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10, // Default page size
                page: 0, // Default page index
              },
            },
          }}
        />
      </div>
      {listResponse?.length === 0 && (
        <div className="no-data">
          <p>No Data Found</p>
        </div>
      )}

      <Loader isLoading={isLoading} />

      {openPopUp && (
        <PopUp message={message} closePopup={() => setOpenPopUp(false)} />
      )}
    </>
  );
};

export default PrepaidExpense;
